import { useEffect } from "react";
import { useAuth } from "@/lib/auth-context";

const CRISP_WEBSITE_ID = "b8976d61-2f91-4742-ba26-5243940c3744";

let crispLoaded = false;

function loadCrisp() {
  if (crispLoaded) return;
  crispLoaded = true;
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;
  const s = document.createElement("script");
  s.src = "https://client.crisp.chat/l.js";
  s.async = true;
  document.getElementsByTagName("head")[0].appendChild(s);
}

// Crisp is for prospects/visitors on the public marketing pages. Logged-in
// customers already have the in-app Help Center ticket queue (see
// HelpCenter.jsx / Admin > Support Queue), so the widget is hidden — not
// unloaded, Crisp doesn't support that cleanly — once a user is authenticated.
export default function CrispChat() {
  const { user } = useAuth();

  useEffect(() => {
    loadCrisp();
  }, []);

  useEffect(() => {
    if (!window.$crisp) return;
    window.$crisp.push(["do", user ? "chat:hide" : "chat:show"]);
  }, [user]);

  return null;
}
